import { en } from './en';
import { de } from './de';

export const translations = {
  en,
  de,
};

export const defaultLanguage = 'de';
export const supportedLanguages = ['en', 'de'];
